import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { roofingSystemPages } from "@/data/roofingSystemContent";

const c = roofingSystemPages["asphalt-shingle-roofing"];

export const Route = createFileRoute("/services/asphalt-shingle-roofing")({
  head: () => ({
    meta: [
      { title: "Asphalt Shingle Roofing Southern California | McKay Roofing & Solar" },
      { name: "description", content: c.heroSubtitle },
      { property: "og:title", content: "Asphalt Shingle Roofing - McKay Roofing & Solar" },
      { property: "og:description", content: c.heroSubtitle },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/asphalt-shingle-roofing" }],
  }),
  component: () => <RoofingServicePage {...c} />,
});
